import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpMaterialsService } from '@cl/core/services/help-materials.service';
import { HelpMaterial } from '@cl/shared/models/help-materials/help-material.model';
import { UsersHelpMaterials } from '@cl/shared/models/help-materials/users-help-materials.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-help-materials-modal',
    standalone: false,
    templateUrl: './help-materials-modal.component.html',
    styleUrl: './help-materials-modal.component.less',
})
export class HelpMaterialsModalComponent implements OnInit {
    loading: boolean = false;

    usersHelpMaterials: UsersHelpMaterials;

    constructor(
        private helpMaterialsService: HelpMaterialsService,
        private messageService: NzMessageService,
        private modalRef: NzModalRef<HelpMaterialsModalComponent>,
        private domSanitizer: DomSanitizer,
    ) {}

    async ngOnInit(): Promise<void> {
        try {
            this.loading = true;
            this.usersHelpMaterials = (await this.helpMaterialsService.getUsersHelpMaterials()).data;
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                return;
            }

            this.messageService.error('Kļūda atlasot paziņojumus');
            this.modalRef.destroy();
            return;
        } finally {
            this.loading = false;
        }
    }

    async downloadFileMaterial(helpMaterialId: number): Promise<void> {
        try {
            this.loading = true;
            await this.helpMaterialsService.downloadFile(helpMaterialId);
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                return;
            }

            this.messageService.error('Kļūda lejupielādējot failu');
        } finally {
            this.loading = false;
        }
    }

    gotoUrlMaterial(urlMaterial: HelpMaterial): void {
        window.open(urlMaterial.url, '_blank');
    }

    sanitizeYtUrl(ytUrl: string): string {
        return this.domSanitizer.sanitize(SecurityContext.RESOURCE_URL, ytUrl);
    }

    close(): void {
        this.modalRef.destroy();
    }
}
